module.exports = __webpack_public_path__ + "static/media/0021_LES_ENSEIGNES_LES_PAINS_SCRABBLE.4cc36eee.png";